var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fixed-toolbar border-top p-2",class:'fixed-' + _vm.position},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }